import { Component, EventEmitter, inject, Input, OnChanges, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Modal, ModalType } from '@app/shared/models/modal.model';
import { RouteParameterInterceptor } from '@app/shared/services/routeParameterInterceptor.service';
import { EventManager } from '@app/shared/utils/event-manager';
import { ButtonComponent } from '../../button/button.component';
import { SharedModule } from '@app/shared/shared.module';
import { NavigationButtonComponent } from '../../navigation-button/navigation-button.component';
import { GamesRepository } from '@app/shared/state/games/games.repository';

export class WizardModalData {
  id: string;
  modalType: ModalType;
  steps: WizardModalSteps[] = [];
  fullScreen: boolean;
  actionUrl?: string;
  initialTab?: number;

  constructor(
    id: string,
    modalType: ModalType,
    steps: Partial<WizardModalSteps[]>,
    fullScreen: boolean,
    actionUrl?: string,
    initialTab?: number
  ) {
    this.id = id;
    this.modalType = modalType;
    this.steps = steps;
    this.fullScreen = fullScreen ?? false;
    this.actionUrl = actionUrl;
    this.initialTab = initialTab ?? 0;
  }
}

export interface WizardModalSteps {
  closeable: boolean;
  imageUrl: string;
  buttonText: string;
}

@Component({
  selector: 'slotcom-wizard-modal',
  templateUrl: './wizard-modal.component.html',
  styleUrls: ['./wizard-modal.component.scss'],
  standalone: true,
  imports: [ButtonComponent, NavigationButtonComponent, SharedModule],
})
export class WizardModalComponent implements OnInit, OnChanges {
  private eventManager = inject(EventManager);
  private routeParameterInterceptorService = inject(RouteParameterInterceptor);
  private dialog = inject(MatDialog);
  private gamesRepo = inject(GamesRepository);

  @Input() wizardModalData: WizardModalData;
  @Input() showArrows: boolean = false;
  @Input() showDots: boolean = true;
  @Input() tab?: number = 0;
  @Output() currentTab = new EventEmitter<number>();

  ngOnInit(): void {
    if (this.wizardModalData?.initialTab !== undefined) {
      this.tab = this.wizardModalData.initialTab;
    }
    this.currentTab.emit(this.tab);
  }

  ngOnChanges(): void {
    this.changeTab(this.tab);
  }

  changeTab(tab: number) {
    this.tab = tab;
    this.currentTab.emit(tab);
  }

  closeByAction(actionUrl: string) {
    if (actionUrl && this.gamesRepo.getAllGames().find((game) => game.gameId === actionUrl)) {
      this.eventManager.closeModal(
        new Modal(this.wizardModalData.id, this.wizardModalData.modalType, this.wizardModalData, '', true)
      );

      this.dialog
        .getDialogById(this.wizardModalData.id)
        .afterClosed()
        .subscribe(() => {
          this.routeParameterInterceptorService.checkActionUrlOld(actionUrl);
        });
    } else if (actionUrl) {
      this.closeModal();

      this.dialog
        .getDialogById(this.wizardModalData.id)
        .afterClosed()
        .subscribe(() => {
          this.routeParameterInterceptorService.checkActionUrlOld(actionUrl);
        });
    } else {
      this.closeModal();
    }
  }

  closeModal(): void {
    this.eventManager.closeModal(
      new Modal(this.wizardModalData.id, this.wizardModalData.modalType, this.wizardModalData)
    );
  }
}
